import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateReports } from '../../../../redux/actions/Diagnostics/diagnostics'
import Input from '../../../../UIComponents/Input/Input'
import ReportFooter from '../ReportFooter'
import { TestReportRightSection } from '../TestReportRightSection'
import './AmylaseLipase.css'


export const AmylaseLipase = () => {
    const dispatch =  useDispatch()
    const indexValue = useSelector(state => state?.diagnosticsInvoiceSummary?.indexValue)
    const reportDataFields = useSelector(state => state?.diagnosticsInvoiceSummary?.getdiagnostic)
    const [ inputValue, setInputValue ] = useState("")
    
    const onInputChange = (e) => {
      const { value, name } = e.target;
      setInputValue(value)
      const filterData = reportDataFields?.testReport?.filter(item => item.test === 'AMYLASE LIPASE')
      let index = 0
      reportDataFields?.testReport?.map((item, i) => {
        if(item.test === 'AMYLASE LIPASE'){
          index = i
        }
        return item
      })
      console.log("index",index);
      const finalFilteredData = filterData[0]?.fields?.map(item => {
        if(item.particular === name){
          item.result = value
        }
        return item
      })
      filterData[0].fields =  finalFilteredData
    reportDataFields.testReport[index]  = filterData[0]
    console.log("knklenknek",reportDataFields?.testReport[index]?.fields);
    setInputValue(reportDataFields?.testReport[index]?.fields)
    dispatch(updateReports(reportDataFields))
    }
   
    return (
        <div>
            <div className='amylase-main'>
                <div className='amylase-container'>
                    <div className='amylase-grid-container'>
                        <div className='padd'>BIO CHEMICAL TEST</div>
                        <div className='padd'>SERUM AMYLASE</div>
                        <Input className='aptinputs' type="number"  name="SERUM AMYLASE" value={reportDataFields?.testReport?.[indexValue]?.fields?.[0]?.result} disabled={!reportDataFields.active} onChange={onInputChange} />
                        <div className='padd'>U/L</div>
                        <div className='padd'>up to 90</div>
                        <div className='padd'></div>
                        <div className='padd'></div>
                        <span className='bil-border1'></span>
                        <div className='padd'>BIO CHEMICAL TEST</div>
                        <div className='padd'>SERUM LIPASE</div>
                        <Input className='aptinputs' type="number" name="SERUM LIPASE" value={reportDataFields?.testReport?.[indexValue]?.fields?.[1]?.result} disabled={!reportDataFields.active} onChange={onInputChange}/>
                        <div className='padd'>U/L</div>
                        <div className='padd'>up to 60</div>
                        <div className='padd'></div>
                        <div className='padd'></div>
                        <span className='bil-border2'></span>
                    </div>
                </div>
                <div className='bgroup-right-sec'>
                    <TestReportRightSection />
                </div>
            </div>
            <br></br>
            <div className='ivf-footer'>
                <ReportFooter />
            </div>
        </div>
    )
}
